import React, { useState, useEffect } from 'react';
import { Container, Spinner, Alert } from 'react-bootstrap';
import { getDatiAzienda } from '../services/api';

function Footer() {
  const [datiAzienda, setDatiAzienda] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDati = async () => {
      try {
        const response = await getDatiAzienda();
        setDatiAzienda(response.data);
      } catch (err) {
        if (err.response && err.response.status === 404) {
          setError("Nessun dato azienda trovato per il footer.");
        } else {
          setError("Errore durante il recupero dei dati azienda per il footer.");
          console.error("Errore durante il recupero dei dati azienda per il footer:", err);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchDati();

    const handleUpdate = () => fetchDati();
    window.addEventListener('datiAziendaUpdated', handleUpdate);

    return () => {
      window.removeEventListener('datiAziendaUpdated', handleUpdate);
    };
  }, []);

  if (loading) {
    return (
      <footer className="footer mt-auto py-3 bg-light">
        <Container className="text-center">
          <Spinner animation="border" size="sm" role="status">
            <span className="visually-hidden">Caricamento...</span>
          </Spinner>
        </Container>
      </footer>
    );
  }

  if (error) {
    return null;
  }

  if (!datiAzienda) {
    return (
      <footer className="footer mt-auto py-3 bg-light">
        <Container className="text-center">
          <Alert variant="info" className="my-0 py-1">Dati azienda non disponibili.</Alert>
        </Container>
      </footer>
    );
  }

  const { denominazione, indirizzo, cap, citta, nazione, piva, reg_imprese, cell, email, home_page } = datiAzienda;

  return (
    <footer className="footer mt-auto py-3 bg-light d-print-none d-none d-lg-block">
      <Container className="text-center text-muted">
        <p className="mb-0" style={{ fontSize: '0.75rem' }}>
          {denominazione && <span>{denominazione}</span>}
          {indirizzo && <span> - {indirizzo}</span>}
          {cap && <span>, {cap}</span>}
          {citta && <span> {citta}</span>}
          {nazione && <span> ({nazione})</span>}
          {piva && <span> - P.IVA: {piva}</span>}
          {reg_imprese && <span> - Reg. Imprese: {reg_imprese}</span>}
          {cell && <span> - Cell: {cell}</span>}
          {email && <span> - Email: <a href={`mailto:${email}`}>{email}</a></span>}
          {home_page && <span> - Web: <a href={home_page} target="_blank" rel="noopener noreferrer">{home_page}</a></span>}
        </p>
      </Container>
    </footer>
  );
}

export default Footer;
